import { RegisterFormComponent } from './register-form/register-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { MovieItemComponent } from './movie-item/movie-item.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { MoviesPosterGridComponent } from './movies-poster-grid/movies-poster-grid.component';
import { CastSlideshowComponent } from './cast-slideshow/cast-slideshow.component';
import { RatingModule } from 'ng-starrating';
import { MoviesCarouselComponent } from './movies-carousel/movies-carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MovieCarouselItemComponent } from './movie-carousel-item/movie-carousel-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentOptionsComponent } from './payment-options/payment-options.component';
import { FilmicFileComponent } from './filmic-file/filmic-file.component';
import { ModalCinemaComponent } from './modal-cinema/modal-cinema.component';
import { PipesModule } from '../core/pipes/pipes.module';
import { ConditionsComponent } from './conditions/conditions.component';
import { PaymentCardComponent } from './payment-card/payment-card.component';
import { PaymentOptionsMiniComponent } from './payment-options-mini/payment-options-mini.component';
import { UiSlideshowComponent } from './ui-slideshow/ui-slideshow.component';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { UiSlidesCarouselComponent } from './ui-slides-carousel/ui-slides-carousel.component';
import { UiPosterComponent } from './ui-poster/ui-poster.component';
import { UiMoviesGridComponent } from './ui-movies-grid/ui-movies-grid.component';
import { UiMovieComponent } from './ui-movie/ui-movie.component';
import { PosterListComponent } from './poster-list/poster-list.component';
import { CommentItemComponent } from './comment-item/comment-item.component';
import { DarkCommentItemComponent } from './dark-comment-item/dark-comment-item.component';
import { UiSlidesCardCarouselComponent } from './ui-slides-card-carousel/ui-slides-card-carousel.component';
import { CriticReviewComponent } from './critic-review/critic-review.component';
import { SmallProfileItemComponent } from './small-profile-item/small-profile-item.component';
import { CommentsSectionComponent } from './comments-section/comments-section.component';
import { NewCommentItemComponent } from './new-comment-item/new-comment-item.component';
import { MovieCommentItemComponent } from './movie-comment-item/movie-comment-item.component';
import { ReviewStarItemComponent } from './review-star-item/review-star-item.component';
import { RaitingComponent } from './raiting/raiting.component';
import { ModalReviewComponent } from './modal-review/modal-review.component';
import { ModalFollowComponent } from './modal-follow/modal-follow.component';
import { MovieFramesGalleryComponent } from './movie-frames-gallery/movie-frames-gallery.component';
import { UiMovieAlternativeComponent } from './ui-movie-alternative/ui-movie-alternative.component';
import { BannerFelixOliverComponent } from './banner-felix-oliver/banner-felix-oliver.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};
@NgModule({
  declarations: [
    CastSlideshowComponent,
    LoginFormComponent,
    MovieCarouselItemComponent,
    MovieItemComponent,
    MoviesCarouselComponent,
    MoviesPosterGridComponent,
    RegisterFormComponent,
    SlideshowComponent,
    PaymentOptionsComponent,
    FilmicFileComponent,
    ModalCinemaComponent,
    ConditionsComponent,
    PaymentCardComponent,
    PaymentOptionsMiniComponent,
    UiSlideshowComponent,
    UiSlidesCarouselComponent,
    UiPosterComponent,
    UiMoviesGridComponent,
    UiMovieComponent,
    PosterListComponent,
    CommentItemComponent,
    DarkCommentItemComponent,
    UiSlidesCardCarouselComponent,
    CriticReviewComponent,
    SmallProfileItemComponent,
    CommentsSectionComponent,
    NewCommentItemComponent,
    MovieCommentItemComponent,
    ReviewStarItemComponent,
    RaitingComponent,
    ModalReviewComponent,
    ModalFollowComponent,
    MovieFramesGalleryComponent,
    UiMovieAlternativeComponent,
    BannerFelixOliverComponent,
  ],
  imports: [CommonModule, RatingModule, CarouselModule, ReactiveFormsModule, PipesModule, FormsModule, SwiperModule],
  exports: [
    CastSlideshowComponent,
    LoginFormComponent,
    MovieCarouselItemComponent,
    MovieItemComponent,
    MoviesCarouselComponent,
    MoviesPosterGridComponent,
    RegisterFormComponent,
    SlideshowComponent,
    PaymentOptionsComponent,
    FilmicFileComponent,
    ModalCinemaComponent,
    ConditionsComponent,
    PaymentCardComponent,
    PaymentOptionsMiniComponent,
    UiSlideshowComponent,
    UiSlidesCarouselComponent,
    UiPosterComponent,
    UiMoviesGridComponent,
    UiMovieComponent,
    PosterListComponent,
    CommentItemComponent,
    DarkCommentItemComponent,
    UiSlidesCardCarouselComponent,
    CriticReviewComponent,
    CommentsSectionComponent,
    NewCommentItemComponent,
    MovieCommentItemComponent,
    ReviewStarItemComponent,
    RaitingComponent,
    ModalReviewComponent,
    ModalFollowComponent,
    MovieFramesGalleryComponent,
    BannerFelixOliverComponent
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})
export class ComponentsModule { }
